<template>
    <v-col
      cols="12"
      md="7"
    >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "Col7"
}
</script>

<style scoped>

</style>